import { heroData } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[64px] md:pt-[72px]"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute top-0 right-0 w-full md:w-2/3 h-full opacity-[0.07]"
          style={{
            background: 'radial-gradient(ellipse at 70% 30%, oklch(0.65 0.24 22) 0%, transparent 70%)',
          }}
        />
        <div className="absolute bottom-0 left-0 w-full md:w-1/2 h-1/2 opacity-[0.05]"
          style={{
            background: 'radial-gradient(ellipse at 30% 80%, oklch(0.74 0.16 82) 0%, transparent 70%)',
          }}
        />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="w-full lg:w-1/2 flex flex-col items-start gap-5 md:gap-6">
            <span className="inline-block px-3 py-1.5 rounded-full text-xs md:text-sm font-medium bg-primary-100/80 text-primary-700 whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-foreground-950 leading-tight tracking-tight">
              {heroData.title}
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-medium">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              {heroData.description}
            </p>

            <div className="flex items-center gap-6 md:gap-8 flex-wrap">
              {heroData.stats.map((stat, i) => (
                <div key={i} className="flex flex-col items-start">
                  <span className="text-xl md:text-2xl font-bold text-primary-600 font-heading">
                    {stat.value}
                  </span>
                  <span className="text-xs md:text-sm text-foreground-500">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3 flex-wrap">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById(heroData.primaryCta.href.replace('#', ''))?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                {heroData.primaryCta.label}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById(heroData.secondaryCta.href.replace('#', ''))?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border-2 border-background-300 text-foreground-700 font-semibold text-sm md:text-base hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                {heroData.secondaryCta.label}
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex items-center justify-center">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Manga%20and%20comic%20books%20floating%20in%20a%20warm%20magical%20library%20atmosphere%20with%20soft%20glowing%20golden%20lights%2C%20manga%20pages%20with%20dynamic%20action%20lines%20swirling%20in%20air%2C%20artistic%20illustration%20style%2C%20warm%20coral%20and%20amber%20color%20tones%2C%20cozy%20reading%20ambiance%2C%20decorative%20Japanese%20manga%20magazine%20covers%2C%20cinematic%20lighting%20with%20dust%20motes%2C%20rich%20textures%2C%20editorial%20composition&width=1000&height=750&seq=hero-manga-2026&orientation=landscape"
                alt="新新漫画 - 高清漫画在线阅读平台，海量漫画资源尽在掌握"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}